<template>
  <div class="icon-group-item">
    <template
      v-if="
        fields &&
        fields.link &&
        fields.link.value &&
        fields.link.value.href &&
        fields.link.value.href.length > 0
      "
    >
      <sc-link v-if="fields && fields.link" :field="fields.link">
        <sc-image v-if="fields && fields.image" :media="fields.image" />
        <sc-text
          tag="span"
          v-if="fields && fields.label"
          :field="fields.label"
          :class="{ topMargin: fields?.topMargin?.value === true }"
        />
      </sc-link>
    </template>
    <template v-else>
      <sc-image v-if="fields && fields.image" :media="fields.image" />
      <sc-text
        tag="span"
        v-if="fields && fields.label"
        :field="fields.label"
        :class="{ topMargin: fields?.topMargin?.value === true }"
      />
    </template>
  </div>
</template>

<script>
import { Link, Image, Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Icon-Group-Item',
  components: {
    ScLink: Link,
    ScImage: Image,
    ScText: Text
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
